/**
 * Client AI model override options for admin UI dropdowns and prompt testing.
 */

export type ModelOption = { value: string; label: string };

export const CLIENT_AI_MODEL_OPTIONS: ModelOption[] = [
  { value: '', label: 'Haiku 4.5 Direct (Default)' },
  { value: 'us.anthropic.claude-3-5-haiku-20241022-v1:0', label: 'Anthropic Claude Haiku 3.5 (Bedrock)' },
  { value: 'us.anthropic.claude-3-5-sonnet-20241022-v2:0', label: 'Anthropic Claude Sonnet 3.5 (Bedrock)' },
  { value: 'us.anthropic.claude-3-7-sonnet-20250219-v1:0', label: 'Anthropic Claude Sonnet 3.7 (Bedrock)' },
  { value: 'global.anthropic.claude-haiku-4-5-20251001-v1:0', label: 'Anthropic Claude Haiku 4.5 (Bedrock)' },
  { value: 'anthropic/claude-3-5-sonnet-20241022', label: 'Anthropic Claude Sonnet 3.5 (Direct)' },
  { value: 'anthropic/claude-3-5-haiku-20241022', label: 'Anthropic Claude Haiku 3.5 (Direct)' },
  { value: 'anthropic/claude-3-opus-20240229', label: 'Anthropic Claude Opus 3 (Direct)' },
  { value: 'anthropic/claude-3-7-sonnet-20250219', label: 'Anthropic Claude Sonnet 3.7 (Direct)' },
  { value: 'anthropic/claude-haiku-4-5-20251001', label: 'Anthropic Claude Haiku 4.5 (Direct)' },
  { value: 'openai.gpt-4o-mini', label: 'OpenAI GPT-4o Mini' },
  { value: 'openai.gpt-4.1-2025-04-14', label: 'OpenAI GPT-4.1' },
  { value: 'openai.gpt-5-mini', label: 'OpenAI GPT-5 Mini' },
  { value: 'openai.gpt-5-nano', label: 'OpenAI GPT-5 Nano' },
  { value: 'google.gemini-2.5-flash', label: 'Google Gemini 2.5 Flash' },
  { value: 'google.gemini-2.5-flash-lite', label: 'Google Gemini 2.5 Flash Lite' },
  { value: 'google.gemini-2.5-pro', label: 'Google Gemini 2.5 Pro' },
  { value: 'google.gemini-3-flash', label: 'Google Gemini 3 Flash' },
  { value: 'google.gemini-3-pro', label: 'Google Gemini 3 Pro' },
  { value: 'moonshotai.kimi-k2.5', label: 'Moonshot Kimi 2.5 (Bedrock)' },
  { value: 'mistral.voxtral-small-24b-2507', label: 'Mistral Voxtral Small 1.0 (Bedrock)' },
];
